import React, { useRef } from 'react';
import { useSetState } from 'utils/functions.utils';
import { Assets, FileUpload } from 'utils/imports.utils';
import './add_saree.component.scss';
import { sareeRate } from '../../../utils/constant.utils';
interface IAddSaree {
  text?: String;
  count: number;
  onClick?: any;
  index?: number;
  data?: any;
  imageData?: any;
  remove?: any;
  sumOfAmount?: any;
  limit?:any;
}

const AddSaree = (props: IAddSaree) => {
  // useRef
  const sareeUploadRef: any = useRef();

  // state
  const [state, setState] = useSetState({
    data: [],
  });

  // logic
  const removeItem = (indexnumber: number) => {
    let removeImage: any = props.data;
    removeImage[index]['images'].splice(indexnumber, 1);
    
    setState({ data: removeImage });
    props.imageData(state.data);
  };

  let index: any = props.index;
  const fileHandle = async (file: any) => {
    let data: any = props.data;
    data[index]['name'] = `saree ${index + 1}`;
    data[index]['images'].push(file);
    data[index]['amount'] =
      index === 0 ? sareeRate.firstOne : sareeRate.secondOne;
    setState({ data });
    props.imageData(state.data);
  };

  return (
    <div className="addsaree_container">
      <div onClick={props.onClick} className="addsaree_remove_text">
        Remove
      </div>
      <div className="addsaree_wrapper">
        <div className="addsaree_top_wrapper">
          <FileUpload
            multiple
            ref={sareeUploadRef}
            onChange={(file: any) => {
              fileHandle(file);
            }}>
            <div
              onClick={() => sareeUploadRef.current.openUpload()}
              className="addsaree_camera_container">
              <img src={Assets.camera} />
            </div>
          </FileUpload>
          <div className="upload_saree_image_wrapper">
            {state.data[index]?.images?.map((res: any, index: number) => {
              return (
                <>
                  <div className="upload_image_position">
                    <img src={res} className="upload_saree_image" />
                    <div
                      className="cancel_button"
                      onClick={() => removeItem(index)}>
                      <img src={Assets.close} alt="delete button" />
                    </div>
                  </div>
                </>
              );
            })}
          </div>
          <div className="addsaree_list_container"></div>
        </div>
        <div className="addsaree_bottom_wrapper">
          <div className="addsaree_saree_count_container">
            Saree {props.count}
          </div>
          <div className="addsaree_saree_price_container">
            <div className="addsaree_price_currency">Rs.</div>
            <div className="addsaree_price_value">
              {index === 0 ? sareeRate.firstOne : sareeRate.secondOne}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSaree;
